import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//import { LoginComponent } from './login/login.component';
import { ReportsComponent } from './reports/reports.component';
import { AuthGuardService } from './shared/auth-guard.service';
import { NotFoundComponent } from './not-found/not-found.component';
import { EnvironmentComponent } from './environment.component';
import { ExternalService } from './shared/external.service';

const APP_ROUTES : Routes = [
	{ path : '', component: EnvironmentComponent },
	//{ path : 'login', component : LoginComponent},
	{ 
		path : 'dashboard', 
		loadChildren : './dashboard/dashboard.module#DashboardModule',
		canActivate: [ AuthGuardService ]/*,
		canActivateChild: [ AuthGuardService ]*/
	},	
	{ 
		path : 'create/:formType', 
		loadChildren : './create-agency/create-agency.module#CreateAgencyModule',
		canActivate: [ AuthGuardService ]/*,
		canActivateChild: [ AuthGuardService ]*/
	},
	{ 
		path : 'reports/:reportType', 
		component : ReportsComponent,
		canActivate: [ AuthGuardService ]/*,
		canActivateChild: [ AuthGuardService ]*/
	},
	{
		path: 'externalRedirect', 
		component: NotFoundComponent, 
		canActivate: [ AuthGuardService ],
		resolve: {externalSite: ExternalService}},		
];

@NgModule({
	imports: [
    RouterModule.forRoot(APP_ROUTES)
  ],
  declarations: [ ],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/app-routing.module.ts